import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../Login.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const sendOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await api.post('/auth/forgot-password', { email });

      if (res.data?.otpSent) {
        navigate(`/reset-password?email=${encodeURIComponent(email)}`);
      } else {
        setError('OTP not sent. Please try again.');
      }
    } catch (err) {
      setError(
        err.response?.data?.error ||
        'Unable to send OTP. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Reset your password</h2>

        <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 24 }}>
          Enter your email and we’ll send you a one-time password.
        </p>

        {error && <div className="custom-alert">{error}</div>}

        <form onSubmit={sendOTP}>
          <input
            className="form-input-custom"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button className="submit-btn" disabled={loading}>
            {loading ? 'Sending...' : 'Send OTP'}
          </button>
        </form>
      </div>
    </div>
  );
}
